export interface Errors {
    username: string;
    email: string;
    password: string;
    confirm_password: string;
    entityType: string;
    url: string;
}

export default function ValidateAuth(values: any) {
    const errors: Errors = {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        entityType: "",
        url: "",
    };

    // Name Errors
    const regEx = /^[0-9a-zA-Z_]+$/;
    if (!values.username || values.username.trim() === "") {
        errors.username = "required";
    } else {
        if (
            values.username.length < 3 ||
            values.username.length > 15 ||
            /\s/g.test(values.username)
        ) {
            errors.username = "invalid";
        }

        if (!values.username.match(regEx)) {
            errors.username = "invalid2";
        }
    }

    // Email Errors
    if (!values.email) {
        errors.email = "required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = "invalid";
    }

    // Password Errors
    if (!values.password) {
        errors.password = "required";
    } else if (values.password.length < 6) {
        errors.password = "too_short";
    } else if (
        !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])(?!\d+$)[A-Za-z\d@$!%*?&]{6,}$/.test(
            values.password
        )
    ) {
        errors.password = "invalid";
    }

    // Confirm Password
    if (
        typeof values.password !== "undefined" &&
        typeof values.confirm_password !== "undefined"
    ) {
        if (values.password !== values.confirm_password) {
            errors.confirm_password = "mismatch";
        }
    }

    // Entity type error
    if (!values.entityType) {
        errors.entityType = "required";
    }

    // url error
    if (values.url && values.url.length > 0) {
        // Regular expression for basic URL validation
        const urlRegex =
            /^(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_.~#?&//=]*))?$/;

        if (!urlRegex.test(values.url)) {
            errors.url = "invalid";
        }
    }

    return errors;
}

// Regex for validate Email
// /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
